var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3A414C",
  fillRule: "evenodd",
  d: "M20 18.3V21H4v-2.7zM17.388 7.555l-2.775-2.81L16.338 3l2.774 2.809zM10.329 14.7H7.556V11.89l6.168-6.245 2.774 2.809z"
})));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.2277ec98.svg";